'use client'
import { Popover } from 'antd'
import { CheckCircleOutlined } from '@ant-design/icons'
import { MouseEventHandler, useState } from 'react'
import { ProfileCopyIcon } from '@/components/svg/ProfileCopyIcon'
import useI18n from 'Hooks/useI18n'

export default function CopyMessage({ message }: { message: string }) {
  const { t } = useI18n()
  const [copied, setCopied] = useState(false)
  const handleVisibleChange = (visible: boolean) => {
    if (!visible) {
      setCopied(false)
    }
  }
  // 复制功能
  const handleCopy: MouseEventHandler<HTMLDivElement> = (e) => {
    e.preventDefault()
    e.stopPropagation()
    navigator.clipboard
      .writeText(message)
      .then(() => {
        setCopied(true)
      })
      .catch(() => {
        setCopied(false)
      })
  }

  return (
    <Popover
      overlayInnerStyle={{
        background: 'rgba(0,0,0,0.4)',
        border: '1px solid rgba(255,255,255,0.8)',
        padding: '1px 14px',
        borderRadius: '30px',
      }}
      align={{
        offset: [0, 5],
      }}
      onOpenChange={handleVisibleChange}
      placement="bottom"
      arrow={false}
      content={
        <span className="cursor-pointer text-xs leading-[30px] text-white">
          {copied ? t('Copied') : t('Copy')}
        </span>
      }
    >
      <div
        className="flex cursor-pointer items-center justify-center"
        onClick={handleCopy}
      >
        {!copied ? (
          <ProfileCopyIcon className="ml-1 cursor-pointer" />
        ) : (
          <CheckCircleOutlined
            style={{ color: '#B2E182' }}
            className="ml-1 cursor-pointer"
          />
        )}
      </div>
    </Popover>
  )
}
